import { DEFAULT_THEME, createTheme, mergeMantineTheme } from '@mantine/core'

import * as UI from '@/components/ui'

import colors from './colors'
import { DEFAULT_PRIMARY_COLOR } from './constants'
import fonts from './fonts'
import { breakpoints, fontSizes, radius, spacing } from './scales'

const theme = createTheme({
  autoContrast: true,
  breakpoints,
  components: UI,
  colors,
  defaultRadius: 'md',
  fontFamily: `${fonts.DMSans.style.fontFamily}, ${DEFAULT_THEME.fontFamily}`,
  fontFamilyMonospace: `${fonts.DMMono.style.fontFamily}, ${DEFAULT_THEME.fontFamilyMonospace}`,
  fontSizes,
  fontSmoothing: true,
  primaryColor: DEFAULT_PRIMARY_COLOR,
  primaryShade: 5,
  radius,
  spacing,
})

export default mergeMantineTheme(DEFAULT_THEME, theme)
